/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Quota_Exhausted_TitleInputs */

const en_quota_exhausted_title = /** @type {(inputs: Quota_Exhausted_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quota reached`)
};

const fr_quota_exhausted_title = /** @type {(inputs: Quota_Exhausted_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quota atteint`)
};

const ms_sg2_quota_exhausted_title = /** @type {(inputs: Quota_Exhausted_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kuota tercapai`)
};

/**
* | output |
* | --- |
* | "Quota reached" |
*
* @param {Quota_Exhausted_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const quota_exhausted_title = /** @type {((inputs?: Quota_Exhausted_TitleInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Quota_Exhausted_TitleInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_quota_exhausted_title(inputs)
	if (locale === "fr") return fr_quota_exhausted_title(inputs)
	return ms_sg2_quota_exhausted_title(inputs)
});